import React, {
  useState, useEffect
} from 'react';

import PropTypes from 'prop-types';

import CheckedLabel from '../Svg/CheckedLabel';

import UncheckedLabel from '../Svg/UncheckedLabel';

import {
  CheckedBox, UnCheckedBox
} from '../Svg';

import './Checkbox.css';

const CheckboxC = (props) => {
  const [ isChecked, toggleChecked ] = useState(false);

  useEffect(() => {
    toggleChecked(props.checked);
  }, [ props.checked ]);

  return (
    <div className={`fm-check ${ props.className || '' }`}>
      {
        isChecked ?
          <div
            className="checkbox-label"
            style={
              {padding: props.padding || ''}
            }
            onClick={(event) => {
              props.onChange && props.onChange(event);
            }}
            automationid={`SalesLead_Div_${ props.automatioIdAttr }ChekedLabel_0`}
          >
            {props.isRadio ? <CheckedBox/> : <CheckedLabel />}
          </div>
          :
          <div
            className="checkbox-label"
            onClick={(event) => {
              props.onChange && props.onChange(event);
            }}
            style={
              {padding: props.padding || ''}
            }
            automationid={`SalesLead_Div_${ props.automatioIdAttr }UnchekedLabel_0`}
          >
            {props.isRadio ? <UnCheckedBox/> : <UncheckedLabel />}
          </div>
      }
      <input
        type="checkbox"
        value={props.value}
        name={props.label}
        automationid={`SalesLead_Input_${ props.automatioIdAttr }Input_0`}
      />
      <span automationid={`SalesLead_Span_${ props.automatioIdAttr }InputLabel_0`} className= {isChecked ? 'checked-label' : 'unchecked-label'}>{props.label}</span>
    </div>
  );
};

CheckboxC.propTypes = {
  automatioIdAttr: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  isRadio: PropTypes.bool
};

export const Checkbox = CheckboxC;
